

import React, { useState } from "react";
import "./SeltosNavbar.css";

export default function SeltosNavbar({ scrollToSection }) {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { name: "Exterior", section: "exterior" },
    { name: "Interior", section: "interior" },
    { name: "Performance", section: "performance" },
    { name: "Safety", section: "safety" },
    { name: "ADAS", section: "adas" },
    { name: "Connectivity", section: "connectivity" },
    { name: "Comfort", section: "comfort" },
    { name: "Convenience", section: "convenience" },

  ];

  const handleClick = (section) => {
    if (scrollToSection) {
      scrollToSection(section);
    }
    setOpen(false);
  };







const handleDownloadBrochure = () => {
    window.open(
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/NEWSELTOS%2Fbrochure%2FNew_seltos_brochure_desk.pdf?alt=media&token=90d10b66-c810-41ca-8645-f7b31219985d", // brochure link yahan change karo
      "_blank"
    );
  };




  return (
    <div className="seltos-navbar">
      <h1 className="logo">New Seltos</h1>

      {/* Desktop Menu */}
      <div className="menu">
        {menuItems.map((item) => (
          <button
            key={item.name}
            onClick={() => handleClick(item.section)}
            className="menu-item"
          >
            {item.name}
          </button>
        ))}
      </div>

      {/* Desktop Buttons */}
      <div className="actions">
        <button
          className="action-btn"
          onClick={() => scrollToSection("showInterest")}
        >
          Show Interest
        </button>

      <button className="action-btn" onClick={handleDownloadBrochure}>
          Download Brochure
        </button>
      </div>


      {/* Mobile "More" + Arrow */}
      <div className="mobile-menu-icon" onClick={() => setOpen(!open)}>
        More {open ? "▲" : "▼"}
      </div>

      {/* Mobile Dropdown */}
      {open && (
        <div className="mobile-dropdown">
          {menuItems.map((item) => (
            <button
              key={item.name}
              onClick={() => handleClick(item.section)}
              className="mobile-dropdown-item"
            >
              {item.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}









